import { useEffect, useRef, useState } from "react";
import { UseInfiniteScrollOptions } from "./types";

export const useInfiniteScroll = <T extends HTMLElement>({
  onLoadMore,
  hasMore = true,
}: UseInfiniteScrollOptions) => {
  const [scrollThreshold, setScrollThreshold] = useState<T | null>(null);
  const loader = useRef(onLoadMore);
  const elementObserver = useRef(
    new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          loader.current();
        }
      },
      { threshold: 1 }
    )
  );

  useEffect(() => {
    loader.current = onLoadMore;
  }, [onLoadMore]);

  useEffect(() => {
    const currentObserver = elementObserver.current;

    if (scrollThreshold && hasMore) {
      currentObserver.observe(scrollThreshold);
    }

    return () => {
      if (scrollThreshold) {
        currentObserver.unobserve(scrollThreshold);
      }
    };
  }, [scrollThreshold, hasMore]);

  return {
    setScrollThreshold,
  };
};
